import { createUseStyles } from 'react-jss'
import { colors } from 'components/common'

const useNotAllowedStyles = createUseStyles({
  notAllowed: {
    display: 'flex',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: '#fff',
    color: colors.gray300
  },
  info: {
    color: colors.red500,
    margin: 0,
    fontSize: 12
  },
  tools: {
    marginTop: '4rem'
  }
})

export { useNotAllowedStyles }
